import React from "react";

import {
  Divider,
  Flex,
  FlexItem,
} from "@patternfly/react-core";

import SchoolHeaderLogos from "./SchoolHeaderLogos/SchoolHeaderLogos";
import SchoolHeaderBrand from "./SchoolHeaderBrand/SchoolHeaderBrand";
import SchoolHeaderActions from "./SchoolHeaderActions/SchoolHeaderActions";
import { useSchoolHeader } from "./hooks/useSchoolHeader";
import { useBreakpoint } from "shared/hooks/useBreakpoint";
import "./SchoolHeaderTop.css";

const SchoolHeaderTop = () => {
  const header = useSchoolHeader();
  const { breakpoint, isNavigationMobile,} = useBreakpoint();
  return (
    <div className={`school-header-top school-header-top--${breakpoint}`}>
      <div className="school-header-top__container">
        <Flex
          alignItems={{ default: "alignItemsCenter" }}
          justifyContent={{
            default: "justifyContentCenter",
            lg: "justifyContentSpaceBetween",
          }}
          flexWrap={{
            default: "wrap",
            lg: "nowrap",
          }}
          spacer={{ default: "spacerLg" }}
        >

          {header.showPartnerLogos && (
            <FlexItem
              order={{
                default: "second",
                lg: "first",
              }}
              style={{
                width: isNavigationMobile ? "100%" : undefined,
                display: "flex",
                justifyContent: isNavigationMobile ? "center" : undefined,
              }}
            >
              <SchoolHeaderLogos variant={breakpoint} />
            </FlexItem>
          )}
          
          {!isNavigationMobile &&
            header.showPartnerLogos &&
            header.showBrand && (
              <Divider
                orientation={{ default: "vertical" }}
                inset={{
                  default: "insetMd",
                  md: "insetNone",
                  lg: "insetSm",
                  xl: "insetXs",
                }}
              />
          )}

          {header.showBrand && (
            <FlexItem
              grow={{ default: "grow" }}
              order={{
                default: "first",
                lg: "second",
              }}
              style={{
                width: isNavigationMobile ? "100%" : undefined,
                textAlign: isNavigationMobile ? "center" : undefined,
              }}
            >
              <SchoolHeaderBrand variant={breakpoint} />
            </FlexItem>
          )}

          {header.showActions && (
            <FlexItem
              order={{
                default: "third",
                lg: "third",
              }}
            >
              <SchoolHeaderActions variant={breakpoint} />
            </FlexItem>
          )}

        </Flex>
      </div>
    </div>
  );
};

export default SchoolHeaderTop;